import { FC } from 'react';
import styled from 'styled-components';
import BREAKPOINTS from 'lib/constants/breakpoints';
import COLORS from 'lib/constants/colors';
import { MessageProps } from 'types/frontEndTypes';
import { partnerConfig } from '@lib/helpers/partner';

const Content = styled.span`
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 1px;
  font-weight: ${partnerConfig?.font?.body.weight || 100};
  padding: 10px 12px;
`;

const BubbleGrowingContainer = styled.div`
  display: flex;
  flex-direction: row;
  transition: height 0.3s cubic-bezier(0.63, 0.89, 0.34, 1);
  position: relative;
`;

const Bubble = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 80%;
  min-width: 44px;
  min-height: 12px;
  flex-direction: column;
  overflow: hidden;

  border: 1px solid rgb(221, 221, 221);

  @media (max-width: ${BREAKPOINTS.medium}) {
    max-width: 80%;
  }

  @media (max-width: ${BREAKPOINTS.small}) {
    max-width: 80%;
  }
`;

const ChatMessage: FC<
  MessageProps & {
    first?: boolean;
    middle?: boolean;
    last?: boolean;
    fontSize?: number;
    ignoreMaxWidth?: boolean;
  }
> = ({
  text,
  first,
  middle,
  last,
  bot,
  banner,
  fontSize = 13,
  ignoreMaxWidth = false,
}) => {
  let borderRadius = '15px';

  if (first && bot) {
    borderRadius = '15px 15px 15px 3px';
  } else if (middle && bot) {
    borderRadius = '3px 15px 15px 3px';
  } else if (last && bot) {
    borderRadius = '3px 15px 15px 15px';
  } else if (!bot) {
    borderRadius = '15px 15px 3px 15px';
  }

  return (
    <div>
      <BubbleGrowingContainer
        style={{
          width: '100%',
          justifyContent: !bot ? 'flex-end' : undefined,
          marginBottom: 5,
          marginTop: first ? 10 : 0,
        }}
      >
        <Bubble
          style={{
            borderRadius,
            backgroundColor: bot ? '#fff' : COLORS.black,
            left: bot ? 0 : undefined,
            maxWidth: ignoreMaxWidth ? 'none' : undefined,
          }}
        >
          {banner}
          <Content style={{ color: bot ? COLORS.black : '#fff', fontSize }}>
            {text}
          </Content>
        </Bubble>
      </BubbleGrowingContainer>
    </div>
  );
};

export default ChatMessage;
